<template>
  <GlobalHeader @changeAnchor="changeAnchor" :hasHeight="headerHeight" :isScroll="headerScroll"  :initBgWhite="initHeaderBgWhite" />
  <main v-bind="$attrs">
    <slot></slot>
  </main>
  <GlobalFooter />
</template>

<script setup>
import GlobalHeader from "./GlobalHeader/index.vue";
import GlobalFooter from "./GlobalFooter/index.vue";
import {
		ref,
		defineProps		
	} from "vue";
  const props = defineProps({
    headerHeight: {
			type: Boolean,
			default: false,
		},
		headerScroll: {
			type: Boolean,
			default: true,
		},
		initHeaderBgWhite: {
			type: Boolean,
			default: false,
		}

	});
	
	const emit = defineEmits(["changeAnchor",]);
	const changeAnchor=function(val){
		console.log("pageWrapper emit被触发",val)
		emit("changeAnchor",val);
	}
	
</script>

<style lang="less" scoped></style>
